<template>
  <fragment>
    <!--LIST-->
    <td
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="checkboxVer"
          hide-details
          class="my-1mdiDeleteOutline"
          @click="checkPerm(index, 'users_son:list')"
        ></v-checkbox>
      </div>
    </td>
    <!--EDIT-->
    <td
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="checkboxEdit"
          hide-details
          class="my-1mdiDeleteOutline"
          @click="checkPerm(index, 'users_son:edit')"
        ></v-checkbox>
      </div>
    </td>
    <!--CREATE-->
    <td
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="checkboxCreate"
          hide-details
          class="my-1mdiDeleteOutline"
          @click="checkPerm(index, 'users_son:create')"
        ></v-checkbox>
      </div>
    </td>
    <!--DESTROY-->
    <td
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="checkboxDelete"
          hide-details
          class="my-1mdiDeleteOutline"
          @click="checkPerm(index, 'users_son:destroy')"
        ></v-checkbox>
      </div>
    </td>
    <td
      :key="Math.random() * (index + 1)"
      style="min-width: 50px;"
    ></td>
  </fragment>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    index: {
      type: Number,
    },
  },
  computed: {
    ...mapState({
      sourcePermisos: state => state.app.sourcePermisos,
    }),
  },
  // eslint-disable-next-line vue/order-in-components
  data() {
    return {
      isLoading: true,
      checkboxVer: false,
      checkboxEdit: false,
      checkboxCreate: false,
      checkboxDelete: false,
    }
  },
  created() {
    this.checkboxVer = this.sourcePermisos[this.index].permisos.includes('users_son:list')
    this.checkboxEdit = this.sourcePermisos[this.index].permisos.includes('users_son:edit')
    this.checkboxCreate = this.sourcePermisos[this.index].permisos.includes('users_son:create')
    this.checkboxDelete = this.sourcePermisos[this.index].permisos.includes('users_son:destroy')
  },
  methods: {
    ...mapMutations(['verifyPermisoZona']),
    checkPerm(pos, ability) {
      let { permisos } = this.sourcePermisos[pos]
      if (permisos.includes(ability)) {
        this.sourcePermisos[pos].permisos = permisos.filter(e => e !== ability)
        if (ability === 'users_son:list') {
          this.sourcePermisos[pos].all.checkboxConfigurationVer = false
        } else if (ability === 'users_son:edit') {
          this.sourcePermisos[pos].all.checkboxConfigurationEdit = false
        } else if (ability === 'users_son:create') {
          this.sourcePermisos[pos].all.checkboxConfigurationCreate = false
        } else if (ability === 'users_son:destroy') {
          this.sourcePermisos[pos].all.checkboxConfigurationDelete = false
        }
      } else {
        permisos = permisos.push(ability)
        this.verifyPermisoZona(this.index)
      }
    },
  },
}
</script>
